import React from 'react';
import EmbeddedModule from './EmbeddedModule';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Wallet, PieChart, TrendingUp, Receipt, Banknote, BarChart3 } from 'lucide-react';

const FEATURES = [
  { icon: Wallet, label: 'Cash-flow Forecasting', desc: '90-day rolling cash projection across MIDs and RBI-classified accounts.' },
  { icon: PieChart, label: 'Tax & GST Reconciliation', desc: 'Auto reconcile 2A/2B, e-invoicing and TDS — DPDP-safe data flows.' },
  { icon: TrendingUp, label: 'Working Capital Optimiser', desc: 'AR/AP aging, ABC-XYZ inventory and supplier health scoring.' },
  { icon: Receipt, label: 'Expense & Reimbursement', desc: 'Policy-aware approvals with AML/whitelist screening on payouts.' },
  { icon: Banknote, label: 'Treasury Dashboard', desc: 'Live FX, FEMA-flagged cross-border movements, FD/CD ladders.' },
  { icon: BarChart3, label: 'Regulatory Reporting', desc: 'Drafts for 9C, 26Q, FATCA-CRS and FIU-IND fed straight from ledgers.' }
];

const FinanceModule = () => (
  <EmbeddedModule
    eyebrow="Sanmiggrc · Finance"
    title="Finance Module"
    tagline="A full-fledged Sanmiggrc Finance workspace built on the Mayank prototype — cash-flow, tax, treasury and regulator-ready reporting in one screen."
    badgeText="Prototype · Sanmiggrc-branded"
    accentClass="from-cyan-700 via-sky-600 to-blue-700"
    embedUrl="https://mayank-ca.lovable.app"
    embedTitle="Personal Finance Dashboard (Mayank prototype)"
    testId="finance-module-page"
    kpis={[
      { label: 'Modules', value: 6 },
      { label: 'Reports Auto-drafted', value: 12 },
      { label: 'Reg-ready Forms', value: '9C · 26Q · FATCA' },
      { label: 'Reconciliation Engines', value: 4 }
    ]}
  >
    <Card data-testid="finance-features">
      <CardHeader>
        <CardTitle>Capabilities</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {FEATURES.map((f) => {
            const Icon = f.icon;
            return (
              <div
                key={f.label}
                data-testid={`finance-${f.label.replace(/\s+/g, '-').toLowerCase()}`}
                className="border border-gray-200 rounded-lg p-4 bg-white hover:border-sky-300 hover:shadow-sm transition-all"
              >
                <div className="w-9 h-9 rounded-md bg-sky-50 border border-sky-100 flex items-center justify-center mb-3">
                  <Icon className="w-4 h-4 text-sky-700" />
                </div>
                <p className="text-sm font-semibold text-gray-900">{f.label}</p>
                <p className="text-xs text-gray-600 mt-1">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  </EmbeddedModule>
);

export default FinanceModule;
